<template>
  <div id="aha-infokontakt">
    <section id="kontakt">
      <h1 class="no-pad" v-html="info.title"></h1>
      <p class="aha-location" v-html="info.location_text"></p>
    </section>

    <section id="organisation">
      <h1 class="no-pad">Organisation</h1>
      <organiser :post="organiser" v-for="organiser in info.children" :key="organiser.uid"></organiser>
    </section>

    <section id="anfahrt" v-if="this.$route.name == 'all'">
      <h1 class="no-pad" v-if="this.$route.name !== 'english'">Anfahrt</h1>
      <h1 class="no-pad" v-else>Directions</h1>
      <div class="aha-directions" v-html="info.directions_text">
      </div>
    </section>

    <section id="credits">
      <p class="aha-location" v-html="info.credits_text">
      </p>
    </section>
  </div>

</template>

<script>
import Organiser from '../components/Organiser.vue'

export default {
  name: 'kontakt',
  components: {
    Organiser
  },
  computed: {
    info () {
      return this.$store.getters.getPageByUID('kontakt')
    },
    festival () {
      return this.$store.getters.getPageByUID('festival')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
.aha-location {
  // padding-top: $gap / 2;
}
.aha-directions, .aha-location {
  li {
    padding: $gap / 2 0;
    width:100%;
    margin-bottom:0;
    border-bottom: 2px solid $font-color;
    @media only screen and (max-width: $phone) {
      border-bottom:1px solid $font-color;
    }
  }
}

#credits {
  .aha-location {
    font-size: $font-size / 3;
    line-height: 1.25;
  }
}

</style>
